/**
 * Generated by orval v8.14.0 🍺
 * Do not edit manually.
 * Remotex.Api, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null
 * OpenAPI spec version: 1.0
 */
import type {
  ApiEnvelopeWebhookDto,
  ApiEnvelopeWebhookEmptyDto,
  ApiEnvelopeWebhookListResponse,
  ApiEnvelopeWebhookTestResponse,
  WebhookCreateRequest,
  WebhookUpdateRequest
} from './schemas';

import { useSfetchMutator } from '../sfetchMutator';


export type webhookListResponse200 = {
  data: ApiEnvelopeWebhookListResponse
  status: 200
}

export type webhookListResponseSuccess = (webhookListResponse200) & {
  headers: Headers;
};
;

export type webhookListResponse = (webhookListResponseSuccess)

export const getWebhookListUrl = () => {




  return `/api/webhooks`
}

export const useWebhookListHook = (): ( options?: RequestInit) => Promise<webhookListResponse> => {

      const customFetcher = useSfetchMutator();
      return ( options?: RequestInit) => {

        return customFetcher(getWebhookListUrl(),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }


export type webhookCreateResponse200 = {
  data: ApiEnvelopeWebhookDto
  status: 200
}

export type webhookCreateResponse400 = {
  data: ApiEnvelopeWebhookDto
  status: 400
}

export type webhookCreateResponseSuccess = (webhookCreateResponse200) & {
  headers: Headers;
};
export type webhookCreateResponseError = (webhookCreateResponse400) & {
  headers: Headers;
};

export type webhookCreateResponse = (webhookCreateResponseSuccess | webhookCreateResponseError)

export const getWebhookCreateUrl = () => {




  return `/api/webhooks`
}

export const useWebhookCreateHook = (): (webhookCreateRequest?: WebhookCreateRequest, options?: RequestInit) => Promise<webhookCreateResponse> => {

      const customFetcher = useSfetchMutator();
      return (webhookCreateRequest?: WebhookCreateRequest, options?: RequestInit) => {

        return customFetcher(getWebhookCreateUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(webhookCreateRequest)
  }
);
      }
  }


export type webhookGetResponse200 = {
  data: ApiEnvelopeWebhookDto
  status: 200
}

export type webhookGetResponse403 = {
  data: ApiEnvelopeWebhookDto
  status: 403
}

export type webhookGetResponse404 = {
  data: ApiEnvelopeWebhookDto
  status: 404
}

export type webhookGetResponseSuccess = (webhookGetResponse200) & {
  headers: Headers;
};
export type webhookGetResponseError = (webhookGetResponse403 | webhookGetResponse404) & {
  headers: Headers;
};

export type webhookGetResponse = (webhookGetResponseSuccess | webhookGetResponseError)

export const getWebhookGetUrl = (id: string,) => {




  return `/api/webhooks/${id}`
}

export const useWebhookGetHook = (): (id: string, options?: RequestInit) => Promise<webhookGetResponse> => {

      const customFetcher = useSfetchMutator();
      return (id: string, options?: RequestInit) => {

        return customFetcher(getWebhookGetUrl(id),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }


export type webhookUpdateResponse200 = {
  data: ApiEnvelopeWebhookDto
  status: 200
}

export type webhookUpdateResponse400 = {
  data: ApiEnvelopeWebhookDto
  status: 400
}

export type webhookUpdateResponse403 = {
  data: ApiEnvelopeWebhookDto
  status: 403
}

export type webhookUpdateResponse404 = {
  data: ApiEnvelopeWebhookDto
  status: 404
}

export type webhookUpdateResponseSuccess = (webhookUpdateResponse200) & {
  headers: Headers;
};
export type webhookUpdateResponseError = (webhookUpdateResponse400 | webhookUpdateResponse403 | webhookUpdateResponse404) & {
  headers: Headers;
};

export type webhookUpdateResponse = (webhookUpdateResponseSuccess | webhookUpdateResponseError)

export const getWebhookUpdateUrl = (id: string,) => {




  return `/api/webhooks/${id}`
}

export const useWebhookUpdateHook = (): (id: string,
    webhookUpdateRequest?: WebhookUpdateRequest, options?: RequestInit) => Promise<webhookUpdateResponse> => {

      const customFetcher = useSfetchMutator();
      return (id: string,
    webhookUpdateRequest?: WebhookUpdateRequest, options?: RequestInit) => {

        return customFetcher(getWebhookUpdateUrl(id),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(webhookUpdateRequest)
  }
);
      }
  }


export type webhookDeleteResponse200 = {
  data: ApiEnvelopeWebhookEmptyDto
  status: 200
}

export type webhookDeleteResponse403 = {
  data: ApiEnvelopeWebhookEmptyDto
  status: 403
}

export type webhookDeleteResponse404 = {
  data: ApiEnvelopeWebhookEmptyDto
  status: 404
}

export type webhookDeleteResponseSuccess = (webhookDeleteResponse200) & {
  headers: Headers;
};
export type webhookDeleteResponseError = (webhookDeleteResponse403 | webhookDeleteResponse404) & {
  headers: Headers;
};

export type webhookDeleteResponse = (webhookDeleteResponseSuccess | webhookDeleteResponseError)

export const getWebhookDeleteUrl = (id: string,) => {




  return `/api/webhooks/${id}`
}

export const useWebhookDeleteHook = (): (id: string, options?: RequestInit) => Promise<webhookDeleteResponse> => {

      const customFetcher = useSfetchMutator();
      return (id: string, options?: RequestInit) => {

        return customFetcher(getWebhookDeleteUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);
      }
  }


export type webhookSendTestResponse200 = {
  data: ApiEnvelopeWebhookTestResponse
  status: 200
}

export type webhookSendTestResponse403 = {
  data: ApiEnvelopeWebhookTestResponse
  status: 403
}

export type webhookSendTestResponse404 = {
  data: ApiEnvelopeWebhookTestResponse
  status: 404
}

export type webhookSendTestResponseSuccess = (webhookSendTestResponse200) & {
  headers: Headers;
};
export type webhookSendTestResponseError = (webhookSendTestResponse403 | webhookSendTestResponse404) & {
  headers: Headers;
};

export type webhookSendTestResponse = (webhookSendTestResponseSuccess | webhookSendTestResponseError)

export const getWebhookSendTestUrl = (id: string,) => {




  return `/api/webhooks/${id}/test`
}

export const useWebhookSendTestHook = (): (id: string, options?: RequestInit) => Promise<webhookSendTestResponse> => {

      const customFetcher = useSfetchMutator();
      return (id: string, options?: RequestInit) => {

        return customFetcher(getWebhookSendTestUrl(id),
  {
    ...options,
    method: 'POST'


  }
);
      }
  }


